import { fixedUi } from '@/i18n/fixedUi';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import {
  ManufacturersPanel,
  ResponsiblePersonsPanel,
} from '@/tiktok-platform/modules/compliance/ComplianceEuEntitiesPanels';
import '@/styles/tiktok-platform/tiktok-product-ops.css';

const DIM_MANUFACTURER = 'manufacturer';
const DIM_RESPONSIBLE = 'responsible';

const DIM_TABS = [
  { id: DIM_MANUFACTURER, labelKey: 'compliance.dimManufacturer' },
  { id: DIM_RESPONSIBLE, labelKey: 'compliance.dimResponsible' },
];

function resolveDim(raw) {
  if (raw === DIM_RESPONSIBLE || raw === 'responsible-person' || raw === 'responsible_persons') {
    return DIM_RESPONSIBLE;
  }
  return DIM_MANUFACTURER;
}

/**
 * 合规资料：制造商与负责人。
 * 布局：查询行 → 工具栏 → 维度（制造商 / 负责人 + 店铺）→ 表格。
 */
export default function ComplianceMaterialsPage() {
  const { t } = useTranslation('workbench');
  const [searchParams, setSearchParams] = useSearchParams();
  const dimFromUrl = resolveDim(searchParams.get('dim'));
  const [dim, setDim] = useState(dimFromUrl);

  useEffect(() => {
    setDim(dimFromUrl);
  }, [dimFromUrl]);

  const switchDim = (next) => {
    setDim(next);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('dim', next);
    setSearchParams(nextParams, { replace: true });
  };

  const dimTabs = (
    <div className="tko-status-tabs tko-dim-tabs" role="tablist" aria-label={fixedUi("合规资料")}>
      {DIM_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={dim === tab.id}
          className={`tko-status-tab${dim === tab.id ? ' tko-status-tab--active' : ''}`}
          onClick={() => switchDim(tab.id)}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );

  return (
    <div className="tko-page">
      {dim === DIM_RESPONSIBLE ? (
        <ResponsiblePersonsPanel dimTabs={dimTabs} />
      ) : (
        <ManufacturersPanel dimTabs={dimTabs} />
      )}
    </div>
  );
}
